import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import State from '@/view/sidebar/store-module/interface';

const state: State = {
    sideBarVisible: false,
};

export default {
    state,
    actions: actions.actions,
    getters: getters.getters,
    mutations: mutations.mutations,
};
